import { NavLink, useLocation } from "react-router-dom";
import useWebData from "../hooks/useWebData"
import useActiveNavbar from "../hooks/useActiveNavbar";
import { useState } from "react";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavbarHeader = [
    {
        name: "Home",
        link: "/",
        child: []
    },
    {
        name: "About Us",
        link: "/about-us",
        child: []
    },
    {
        name: "Fleet",
        link: "/fleet",
        child: []
    },
    {
        name: "Opening Hours",
        link: "/opening-hours",
        child: []
    },
    {
        name: "Locations",
        link: "/locations",
        child: []
    },
    {
        name: "Blog",
        link: "/blog",
        child: []
    },
    {
        name: "FAQ",
        link: "/faq",
        child: []
    },
    {
        name: "Contact Us",
        link: "/contact-us",
        child: []
    },
    {
        name: "My Booking",
        link: "/my-booking",
        child: []
    },
];
export const TopBar = () => {
    const { webData }: any = useWebData();
    const { selected, setSelected }: any = useActiveNavbar();
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();

    const callPhone = () => {
        if (webData?.websitePhone) {
            window.location.href = `tel:${webData?.websitePhone}`;
        }
    };

    if (
        location.pathname.replace("/", "").includes("carrental/reservations/print-quote")
        || location.pathname.replace("/", "").includes("public/booking/rental-agreement")
    ) {
        return <></>
    }

    return (
        <>
            <nav className={`flex fixed top-0 justify-between items-center px-8 py-2 w-full h-[140px] z-20 shadow-md bg-[#ff6926]`}
                style={{
                    backgroundColor: webData?.websiteHeaderColor
                }}
            >
                <div className="max-lg:flex max-lg:items-center max-lg:justify-between max-lg:w-full">
                    <div className="flex items-center gap-20 py-2">
                        <NavLink to="/" className="z-10" onClick={() => setSelected("/")}>
                            <img
                                className="logo-img h-[140px] w-auto object-contain"
                                //change from dynamic logo to static
                                // src={webData?.tentantLogo}
                                src="/images/jjvanslogo.png"
                                alt="logo"
                            />
                        </NavLink>
                    </div>

                    <div className="lg:hidden">
                        <button onClick={() => setSidebarOpen(true)} className="text-white">
                            <span className="material-symbols-outlined text-3xl">menu</span>
                        </button>
                    </div>
                </div>

                {webData?.websitePhone && (
                    <div
                        className="hidden lg:flex items-center gap-3 text-white text-xl font-semibold cursor-pointer hover:text-black"
                        onClick={callPhone}
                    >
                        <FontAwesomeIcon icon={faPhone} className="text-xl" />
                        <span className="whitespace-nowrap">{webData?.websitePhone}</span>
                    </div>
                )}

                <ul className="hidden lg:flex gap-6 font-medium text-sm items-center">
                    {
                        NavbarHeader.map((item: any, index: number) => (
                            <NavLink
                                to={item.link}
                                key={index}
                                onClick={() => setSelected(item.link)}
                            >
                                <li className={` pb-1 cursor-pointer text-center hover:text-black hover:border-b-2 hover:border-black ${selected === item.link
                                    ? `text-black border-b-2 border-black`
                                    : `text-white`
                                    }`}>{item.name}</li>
                            </NavLink>

                        ))
                    }
                </ul>
            </nav>

            <div className={`fixed top-0 left-0 w-[300px] bg-white overflow-auto h-full px-2 bg-secondary z-50 shadow-lg transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}`}>
                <div className="flex justify-end items-center p-2 border-b">
                    <button
                        onClick={() => setSidebarOpen(false)}
                        style={{
                            color: webData?.websiteHeaderColor
                        }}
                    >
                        <span className="material-symbols-outlined text-2xl">
                            close
                        </span>
                    </button>
                </div>

                <div className="p-4 space-y-4">
                    {webData?.websitePhone && (
                        <div
                            className="flex items-center gap-3 text-black text-base font-semibold cursor-pointer hover:text-[#ff6926]"
                            onClick={callPhone}
                        >
                            <FontAwesomeIcon icon={faPhone} className="text-lg" />
                            <span className="whitespace-nowrap">{webData?.websitePhone}</span>
                        </div>
                    )}

                    <hr className="border-gray-300" />

                    <div className="space-y-2">
                        {NavbarHeader?.map((item, idx) => (
                            <div key={idx}>
                                <NavLink
                                    to={item?.link}
                                    onClick={() => {
                                        setSelected(item?.link)
                                        setSidebarOpen(false)
                                    }}
                                >
                                    <span className={`block text-sm font-medium py-2 cursor-pointer text-black hover:border-b-2 hover:border-primary ${selected === item?.link
                                        ? `text-primary border-b-2 border-primary`
                                        : `text-black`
                                        }`}>{item?.name}</span>
                                </NavLink>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {
                isSidebarOpen && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40"
                        onClick={() => setSidebarOpen(false)}
                    />
                )
            }
        </>

    )
}